import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.pruefplan-hinzufuegen';
import * as api from '../../../clients/qschecks';

@Injectable()
export class QschecksPruefplanHinzufuegenEffects {

    PruefplanHinzufuegen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_PRUEFPLAN_HINZUFUEGEN),
        mergeMap((x: ac.PostPruefplanHinzufuegenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postPruefplanHinzufuegen(x.pruefplanModelRequest).pipe(
                map((result: any) => {
                    return new ac.PostPruefplanHinzufuegenErfolgreichAction(result, x.pruefplanModelRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostPruefplanHinzufuegenFehlerAction(error, x.pruefplanModelRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AdminCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AdminCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.AdminCommandService);
        }
        return this.service;
    }
}
